import { ViewModel,View } from "binder"
import  { ExpanderView } from "./expander-view"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { BooleanPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import { ChildAcceptableFormBuilderElement, FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { ComponentListStore } from "src/formBuilder/formBuilder/templateEditor/templateEditor-viewModel";
import { GridComponent } from "../grid/grid-viewModel";

export class ExpanderComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Expander';
        this.canAcceptContent = false;
        this.canAcceptMultipleContent = false;

        this.addProperty("DefaultIsOpen","data-b-comp-expanded",new BooleanPropertyType(this),false,false);
    
        this.addAttachedProperty
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new ExpanderViewModel(parent);

        return result;
    }
}
export class ExpanderViewModel extends ChildAcceptableFormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    onDataContextSet(): void {
        let header = new GridComponent(this).Create(this);
        let body = new GridComponent(this).Create(this);
        header.DataContext = this.DataContext;        
        body.DataContext = this.DataContext;       
        this.children.update(...[header,body]); 
        this.header = header;
        this.body = body;
    }
    GetDefaultView(): View <ViewModel> {
        return new ExpanderView();
    }
    public getTypeId(): string {
        return "VM-8FAE8F84-8C27-4A83-B698-2B7507C75BFD"
    }
    public set header(v: ViewModel) { this._header = v; } public get header(): ViewModel { return this._header;} private _header: ViewModel;
    public set body(v: ViewModel) { this._body = v; } public get body(): ViewModel { return this._body;} private _body: ViewModel;
        
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitExpander(this,parameter);
    }
    addChildInternal(element: FormBuilderElement, mouseEvent?: MouseEvent): void {
        if(this.children.length==2){
            this.children.clear();
        }
        this.children.push(element);
        if(this.children.length==1){
            this.header = element;
        }else{
            this.body = element;
        }
    }
    removeChild(element: FormBuilderElement): void {
    }
    override canAcceptContentAtDeserializationTime(): Boolean {
        return true;
    }    
}
